import { useState } from 'react';

import { Space } from '@/components/base';
import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import service from '@/services';
import useWorkspaceStore from '@/stores/WorkspaceStore';

import { CompoundConnectModal } from '../../components/ConnectModal';
import type { FreshdeskInfo } from '../types/types';

type Props = {
  onConnectComplete: (info: FreshdeskInfo) => void;
};

const FreshdeskConnectModal = (props: Props) => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const color = useColor();
  const { closeModal } = useModalContext();

  const [subDomain, setSubDomain] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');

  const onConnectClick = async () => {
    if (subDomain.trim() === '') return;
    if (!currWorkspace) return;
    const data = await service.freshdesk.createFreshdeskInfo(
      currWorkspace.alias,
      subDomain,
      token,
    );
    if (data) {
      props.onConnectComplete(data);
      closeModal();
    } else {
      setError('Your token is invalid. Please check again!');
    }
  };
  return (
    <CompoundConnectModal
      title="Connect Freshdesk"
      description="Subdomain and access token are required to connect to Freshdesk"
      error={error}
      connectButtonDisabled={subDomain.trim() === '' || token.trim() === ''}
      handleConnectWorkspace={onConnectClick}
    >
      <Typo type="label1" weight="m">
        Subdomain
      </Typo>
      <Space h="4px" />
      <Typo type="label2" color={color.gray700}>
        Enter the subdomain of your Freshdesk URL.
      </Typo>
      <Space h="4px" />
      <Typo type="body2" color={color.gray700}>
        (ex. https://<b>your-subdomain</b>.freshdesk.com)
      </Typo>
      <Space h="16px" />
      <Input
        placeholder="Subdomain"
        sizeType="m"
        value={subDomain}
        onChange={(e) => setSubDomain(e.target.value)}
      />
      <Space h="24px" />
      <Typo type="label1" weight="m">
        Access token
      </Typo>
      <Space h="4px" />
      <Typo type="label2" color={color.gray700}>
        Enter the access token of Freshdesk.
      </Typo>
      <Space h="16px" />
      <Input
        placeholder="Access token"
        sizeType="m"
        value={token}
        onChange={(e) => setToken(e.target.value)}
      />
    </CompoundConnectModal>
  );
};

export default FreshdeskConnectModal;
